import { RadioButton } from '@/components/RadioButton';
import { Process } from '@/utils/process';
import { cn } from '@skand/ui';

export interface ProcessRowProps {
  process: Process;
  onSelect: (process: Process) => void;
  isSelected: boolean;
}

export const ProcessRow = ({ process, onSelect, isSelected }: ProcessRowProps) => {
  return (
    <div
      className={cn(
        'inline-flex',
        'flex-row',
        'items-center',
        'typo-text-small',
        'text-neutral-800',
        'whitespace-nowrap',
        'px-2',
        'py-1',
        'ml-2',
      )}
    >
      <RadioButton
        checked={isSelected}
        className="pr-2 pt-[5px]"
        id="process"
        onChange={() => onSelect(process)}
        value={process.name}
      />
      <div className="pointer-events-none px-1">{process.name}</div>
    </div>
  );
};
